// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordionSubtitle_root__FPzxU","rootContent":"AccordionSubtitle_rootContent__7mJLD"};